import { Component, OnInit,NgModule } from '@angular/core';
import { CampaignService } from '../campaign.service';
import { chain } from 'lodash';
import { Router, Params, ActivatedRoute } from '@angular/router';
@Component({
    selector: 'campaign-transactions',
    templateUrl: './campaign-transactions.component.html',
    styleUrls: ['./campaign-transactions.component.scss']
})

export class CampaignTransactionsComponent implements OnInit {
  constructor(private campaignService: CampaignService,private activatedRoute: ActivatedRoute) { }
  campaignId: string = "";
  clientId: string = "";
  apiKey: string = "";
  pageSize: string = "50";
  transactionList: any[] = [];
  loading: boolean = false;
  nextPageKey?: Object;
  showAlert = false;
  errorMessage: string = null;

  ngOnInit() {
    this.activatedRoute.params.subscribe(value => {
      console.log("subscribe value = ",value);
     
      // this.campaignId = value.campaignId;
      // this.campaignId = '1166';
      // this.queryTransactions();
    });
  }
  // query transactions
  queryTransactions(){
    this.getTransactionList(false);
  }

  replaceContentJsonString(preJsonContent: string, prejsonElements: HTMLCollectionOf<Element>, key: string) {
    const replaceRegContent = preJsonContent.replace(`"client_id": ""`, `<text style="background-color:#FFFF00;color:red">"client_id": ""</text>`);
    prejsonElements[key].innerHTML = replaceRegContent;
  }

  highlightClientId() {
    setTimeout(() => {
      const prejsonElements = document.getElementsByClassName("pre-json");
      let regex = /\"client_id\": \"*\"/;
      if (prejsonElements) {
        for (const key in prejsonElements) {
          const preJsonContent = prejsonElements[key].innerHTML;
          if (preJsonContent) {
            if (preJsonContent.indexOf("\"client_id\": \"\"") != -1) {
              //If there is a client_id field and it is empty, it will be highlighted directly.
              this.replaceContentJsonString(preJsonContent, prejsonElements, key);
            } else if(regex.test(preJsonContent)) {
              // if exist client_id and not empty then skip
              continue;
            } else {
              //If the client_id field does not exist, add the empty field and highlighted.
              let preJsonContentJsonObject = JSON.parse(preJsonContent);
              preJsonContentJsonObject.client_id = "";
              const newPreJsonContentJsonString = JSON.stringify(preJsonContentJsonObject, null, 2);
              this.replaceContentJsonString(newPreJsonContentJsonString, prejsonElements, key);
            }
          }
        }
      }
    }, 10);
  }

  // export transactions
  exportTransactions(){
    this.loading = true;
    this.campaignService.exportTransactionsByCampaign(this.campaignId,null).subscribe(res => {
      const jsonTransaction = chain(res.transactions)
          .map(item => {
            item.transactionData = JSON.parse(item.transactionData)
            delete item.campaignId;
            return item;
          }).value();
      this.campaignService.saveJSON(jsonTransaction, `NewData_${this.campaignId}_${new Date().getTime()}.json`);
      // this.transactionList = jsonTransaction;
      // this.nextPageKey = res.nextPageKey;
      this.loading = false;
    }, err => {
      this.loading = false;
      return err;
    });
  }

  // export transactions source
  exportTransactionsSource(){
    this.loading = true;
    this.campaignService.exportTransactionsByCampaign(this.campaignId,null).subscribe(res => {
      const jsonTransaction = chain(res.transactions)
          .map(item => {
            item.transactionData = JSON.parse(item.transactionData)
            delete item.transactionData.data_provider_identifier;
            delete item.transactionData.recordNumber;
            delete item.transactionData.ingestedTimestamp;
            delete item.transactionData.process_type;
            delete item.transactionData.created_dt;
            delete item.campaignId;
            return item;
          }).value();
      this.campaignService.saveJSON(jsonTransaction, `SourceData_${this.campaignId}_${new Date().getTime()}.json`);
      // this.transactionList = jsonTransaction;
      // this.nextPageKey = res.nextPageKey;
      this.loading = false;
    }, err => {
      this.loading = false;
      return err;
    });
  }

  // query more transctions
  onLoadMoreClick(): void {
    if (this.nextPageKey) {
      this.loadMoreList();
    }
  }

  getTransactionList(loadMore: boolean){
    this.loading = true;
    this.errorMessageClose();
    this.campaignService.getTransactionsList(this.clientId, this.apiKey, this.pageSize, this.nextPageKey).subscribe(res => {
      console.log("res = ",res);
      if(res && res.status === 0){
        const jsonTransaction = chain(res.data.items)
        .map(item => {
          item.transactionData = JSON.parse(item.transactionData)
          item.transactionDataSource = JSON.parse(JSON.stringify(item.transactionData));
          delete item.transactionDataSource.data_provider_identifier;
          delete item.transactionDataSource.recordNumber;
          delete item.transactionDataSource.ingestedTimestamp;
          delete item.transactionDataSource.process_type;
          delete item.transactionDataSource.created_dt;
          return item;
        }).value();
        this.transactionList = loadMore ? this.transactionList.concat(jsonTransaction) : jsonTransaction;
        this.nextPageKey = res.data.lastEvaluatedKey;
        this.loading = false;
        this.highlightClientId();
      }else{
        this.transactionList = [];
        this.nextPageKey = null;
        this.loading = false;
        this.errorMessageShow(res.error);
      }
     
    }, err => {
      this.loading = false;
      this.errorMessageShow(err);
      return err;
    });
  }

  errorMessageClose(): void {
    this.showAlert = false;
    this.errorMessage = '';
  }

  errorMessageShow(err): void {
    this.showAlert = true;
    this.errorMessage = err;
  }

  loadMoreList() {
    this.getTransactionList(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/campaign/campaign-transactions/campaign-transactions.component.ts